import { ReadyState } from "./ready-state.types";
let state = ReadyState.loading;
export function setReadyState(newState) {
    state = newState;
}
export function getReadyState() {
    return state;
}
